// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PROGRESS_STATUSES } from 'symbols';
import { GetTransactionListError } from '../../../finance-register/states/finance-register/finance-register.actions';
import { CompletedWorkService } from '../../services/completed-work.service';
import {
  CreateCompletedWorkTransaction,
  CreateCompletedWorkTransactionSuccess,
  DeleteCompletedWorkTransaction,
  DeleteCompletedWorkTransactionSuccess,
  GetCompletedWorkTransactions,
  GetCompletedWorkTransactionsFail,
  GetCompletedWorkTransactionsSuccess,
  GetSummaryByUserId,
  GetSummaryGroupedByWorker,
  UpdateCompletedWorkTransaction
} from './completed-work.actions';
import { COMPLETED_WORK_STATE_DEFAULT, CompletedWorkStateModel } from './completed-work.model';

@State({ name: 'CompletedWork', defaults: COMPLETED_WORK_STATE_DEFAULT })
@Injectable()
export class CompletedWorkState {

  constructor(private completedWorkService: CompletedWorkService) {
  }

  @Selector()
  static currentTransactions(state: CompletedWorkStateModel): CompletedWorkStateModel['currentTransactions'] {
    return state.currentTransactions;
  }

  @Selector()
  static loadTransactionsStatus(state: CompletedWorkStateModel): CompletedWorkStateModel['loadTransactionsStatus'] {
    return state.loadTransactionsStatus;
  }

  @Selector()
  static loadSummaryStatus(state: CompletedWorkStateModel): CompletedWorkStateModel['loadSummaryStatus'] {
    return state.loadSummaryStatus;
  }

  @Selector()
  static summaryCompletedWork(state: CompletedWorkStateModel): CompletedWorkStateModel['summaryCompletedWork'] {
    return state.summaryCompletedWork;
  }

  @Selector()
  static summaryCompletedWorkGroupedByUserId(state: CompletedWorkStateModel): CompletedWorkStateModel['summaryCompletedWorkGroupedByUserId'] {
    return state.summaryCompletedWorkGroupedByUserId;
  }


  @Action(GetCompletedWorkTransactions)
  getCompletedWorkTransactions(ctx: StateContext<CompletedWorkStateModel>, {
    filter,
    lazy
  }: GetCompletedWorkTransactions): void {
    if (lazy) {
      const next = ctx.getState().currentTransactions?.links?.next;
      if (next) {
        ctx.patchState({
          loadTransactionsStatus: PROGRESS_STATUSES.IN_PROGRESS
        });
        this.completedWorkService.getTransactionsByUserIdLazy(next).subscribe({
          next: transactions => ctx.dispatch(new GetCompletedWorkTransactionsSuccess(transactions, lazy)),
          error: error => ctx.dispatch(new GetTransactionListError(error))
        });
      }
    } else {
      ctx.patchState({
        loadTransactionsStatus: PROGRESS_STATUSES.IN_PROGRESS
      });
      this.completedWorkService.getTransactionsByUserId(filter).subscribe({
        next: transactions => ctx.dispatch(new GetCompletedWorkTransactionsSuccess(transactions, lazy)),
        error: error => ctx.dispatch(new GetCompletedWorkTransactionsFail(error))
      });
    }
  }


  @Action(GetCompletedWorkTransactionsSuccess)
  getCompletedWorkTransactionsSuccess(ctx: StateContext<CompletedWorkStateModel>, {
    transactions,
    lazy
  }: GetCompletedWorkTransactionsSuccess): void {
    ctx.patchState({
      currentTransactions: lazy
        ? {
          ...ctx.getState().currentTransactions,
          data: [...ctx.getState().currentTransactions.data, ...transactions.data],
          links: transactions.links,
          meta: transactions.meta
        }
        : transactions,
      loadTransactionsStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(GetCompletedWorkTransactionsFail)
  getCompletedWorkTransactionsFail(ctx: StateContext<CompletedWorkStateModel>, { error }: GetCompletedWorkTransactionsFail): void {
    ctx.patchState({
      loadTransactionsStatus: PROGRESS_STATUSES.FAIL
    });
    console.log('GetCompletedWorkTransactionsFail', error);
  }


  @Action(GetSummaryByUserId)
  getSummaryByUserId(ctx: StateContext<CompletedWorkStateModel>, { userId, date }: GetSummaryByUserId): void {
    ctx.patchState({
      loadSummaryStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.completedWorkService.getSummaryByUserId(userId, date).subscribe({
      next: summary => {
        ctx.patchState({
          summaryCompletedWork: summary,
          loadSummaryStatus: PROGRESS_STATUSES.SUCCESS
        });
      },
      error: error => {
        ctx.patchState({
          loadSummaryStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }

  @Action(GetSummaryGroupedByWorker)
  getSummaryGroupedByWorker(ctx: StateContext<CompletedWorkStateModel>, { date }: GetSummaryGroupedByWorker): void {
    ctx.patchState({
      loadSummaryStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.completedWorkService.getSummaryGroupByUserId(date).subscribe({
      next: summary => {
        ctx.patchState({
          summaryCompletedWorkGroupedByUserId: summary,
          loadSummaryStatus: PROGRESS_STATUSES.SUCCESS
        });
      },
      error: error => {
        ctx.patchState({
          loadSummaryStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }

  @Action(CreateCompletedWorkTransaction)
  createCompletedWorkTransaction(ctx: StateContext<CompletedWorkStateModel>, { transaction }: CreateCompletedWorkTransaction): void {
    this.completedWorkService.createTransaction(transaction).subscribe({
      next: data => ctx.dispatch(new CreateCompletedWorkTransactionSuccess(data)),
      error: error => {
        console.error('CreateCompletedWorkTransaction error', error);
      }
    });
  }

  @Action(UpdateCompletedWorkTransaction)
  updateCompletedWorkTransactionSuccess(ctx: StateContext<CompletedWorkStateModel>, {
    transaction,
    id
  }: UpdateCompletedWorkTransaction): void {
    this.completedWorkService.updateTransaction(transaction, id).subscribe({
      next: data => ctx.dispatch(new CreateCompletedWorkTransactionSuccess(data)),
      error: error => {
        console.error('CreateCompletedWorkTransaction error', error);
      }
    });
  }

  @Action(DeleteCompletedWorkTransaction)
  deleteCompletedWorkTransaction(ctx: StateContext<CompletedWorkStateModel>, { id }: DeleteCompletedWorkTransaction): void {
    this.completedWorkService.deleteTransaction(id).subscribe({
      next: () => ctx.dispatch(new DeleteCompletedWorkTransactionSuccess()),
      error: error => {
        console.error('DeleteCompletedWorkTransaction error', error);
      }
    });
  }
}


